var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: { title: "LBL0000319", noMarginPadding: true },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && _vm.isWriting
                    ? _c("c-btn", {
                        attrs: { label: "LBL0000253", icon: "add" },
                        on: { btnClicked: _vm.addArea },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.isWriting
                    ? _c("c-btn", {
                        attrs: { label: "LBL0000254", icon: "place" },
                        on: { btnClicked: _vm.selectMap },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 container",
              },
              [
                _c(
                  "q-img",
                  {
                    style: {
                      height: "575px",
                      width: String(_vm.ratio * 575) + "px",
                    },
                    attrs: {
                      src: _vm.mapSrc,
                      "spinner-color": "white",
                      contain: true,
                    },
                  },
                  [
                    _vm.workPermit.maps && _vm.workPermit.maps.length > 0
                      ? _vm._l(_vm.workPermit.maps, function (item, idx) {
                          return _c(
                            "VueDraggableResizable",
                            {
                              key: idx,
                              ref: "markImage",
                              refInFor: true,
                              staticClass: "markImage",
                              attrs: {
                                resizable: false,
                                parent: true,
                                draggable: _vm.editable && _vm.isWriting,
                                x: item.locationXcoordinate,
                                y: item.locationYcoordinate,
                                w: 40,
                                h: 40,
                                grid: [10, 10],
                              },
                              on: {
                                dragging: (x, y) => _vm.onDrag(x, y, item),
                              },
                            },
                            [_vm._v(" " + _vm._s(idx + 1) + " ")]
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 container",
              },
              [
                _vm.workPermit.maps && _vm.workPermit.maps.length > 0
                  ? _vm._l(_vm.workPermit.maps, function (item, idx) {
                      return _c("div", { key: idx, staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-9" },
                          [
                            _c("c-multi-select", {
                              ref: "mark-work-multi-select-" + item.id,
                              refInFor: true,
                              staticClass: "q-pt-md",
                              attrs: {
                                required: true,
                                disabled: !_vm.isWriting,
                                editable: _vm.editable,
                                comboItems: _vm.supplyItems,
                                isObject: true,
                                valueText: "sopWorkTypeName",
                                valueKey: "sopWorkTypeCd",
                                itemText: "codeName",
                                itemValue: "code",
                                label:
                                  _vm.$comm.getLangLabel("LBL0000320", "SWP") +
                                  (idx + 1),
                                name: "resultTypes",
                              },
                              on: { datachange: _vm.datachange },
                              model: {
                                value: item.resultTypes,
                                callback: function ($$v) {
                                  _vm.$set(item, "resultTypes", $$v)
                                },
                                expression: "item.resultTypes",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-3",
                            staticStyle: { position: "relative", top: "20px" },
                          },
                          [
                            _vm.editable && _vm.isWriting
                              ? _c("c-btn", {
                                  attrs: {
                                    label: "LBL0000275",
                                    icon: "remove",
                                  },
                                  on: {
                                    btnClicked: function ($event) {
                                      return _vm.removePoint(idx)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }